import { Button } from "primereact/button";
import { useGraph } from "../../../hooks/useGraph";
import "./zoom.scss"
import { useTranslation } from 'react-i18next';

export const Zoom = () => {

  const {t: translate} = useTranslation();

  const {zoomIn,zoomOut,zoomToFitNodes,reRoute} = useGraph()
  return (
    <>
      <div className="zoomTreatment">
        <Button
          tooltip="Zoomer"
          tooltipOptions={{ position: 'left' }}
          onClick={() => {
            zoomIn()
          }}
          className="p-button-text block"
          icon="pi pi-plus"
        />
        <Button
          tooltip="Dézoomer"
          tooltipOptions={{ position: 'left' }}
          onClick={() => {
            zoomOut()
          }}
          className="p-button-text block"
          icon="pi pi-minus"
        />
        <Button
          tooltip="Recentrer"
          tooltipOptions={{ position: 'left' }}
          onClick={() => {
              zoomToFitNodes()
          }}
          className="p-button-text block"
          icon="pi pi-map-marker"
        />
        <Button
          tooltip={translate("button.order")}
          tooltipOptions={{ position: 'left' }}
          onClick={() => {
            reRoute()
          }}
          className="p-button-text block"
          icon="pi pi-align-justify"
        />
      </div>
    </>
  );
};
